import { useEffect, useState } from 'react'

export function useActivityTimelineNow(streaming) {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (!streaming) return undefined
    const id = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(id)
  }, [streaming])
  return now
}
